import { DownloadK8sAgentBaseDataProvider } from './DownloadK8sAgentBaseDataProvider';
import { GetAvailableCompaniesResponse, K8sScriptData } from '../types/download-k8s-agent-data';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export class DownloadK8sAgentGzDataProvider extends DownloadK8sAgentBaseDataProvider {
  /**
   * Gets the required data to display in the Kubernetes script.
   * @returns
   */
  public async getK8sScriptData(companyId: string): Promise<Partial<K8sScriptData>> {
    const data = (await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      payload: {
        companyId: companyId ?? Application.Main.getUserCompany().id,
      },
      endpoint: 'Packages',
      method: 'getK8sScriptData',
    })) as Partial<K8sScriptData>;

    // if not successful, throw an error to trigger the buildErrorView
    if (!data.success) {
      throw new Error('Failed to fetch Kubernetes script data');
    }

    return data;
  }

  /**
   * Fetches a list of companies that have kspmUsable == true. This will be used for dropdown validation.
   * @returns A list of company IDs that have KSPM enabled.
   */
  public async getAvailableCompanyIdsWithKspm(): Promise<string[]> {
    const response = (await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: {
        options: {
          source: 'fromKSPM',
        },
      },
      endpoint: 'Company',
      method: 'getAvailableCompanies',
    })) as GetAvailableCompaniesResponse;

    return (response?.data ?? []).map(company => company._id);
  }
}
